import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import client from './client';
import type { PulseResponseDto } from '../types/api';

export const pulseKeys = {
  all:  () => ['pulse']       as const,
  list: () => ['pulse', 'list'] as const,
};

export function usePulseList() {
  return useQuery({
    queryKey: pulseKeys.list(),
    queryFn: () => client.get<PulseResponseDto[]>('/pulse').then((r) => r.data),
  });
}

export function useSubmitPulse() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { score: number; comment?: string }) =>
      client.post<PulseResponseDto>('/pulse', body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: pulseKeys.all() }),
  });
}

export function useDeletePulse() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => client.delete(`/pulse/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: pulseKeys.all() }),
  });
}
